module.exports = "<p>\r\n  auditorias works!\r\n</p>\r\n"